import React from 'react';

import binaries from '../../data/binaryData';

//Función principal
const BinaryState = props => {
    //Tomo los props
    const { value } = props;
    //Renderizo
    return (
        <span className={`badge badge-${ binaries[parseInt(value)].style }`}>
            { binaries[parseInt(value)].descripcion }
        </span>
    );
};

export default BinaryState;